// extracted by mini-css-extract-plugin
module.exports = {"item":"Menu-item-2ictz","link":"Menu-link-1ipcK","active":"Menu-active-1Q2vJ","name":"Menu-name-2Vtnu"};